import { PERMISSIONS } from "@/constants/permissions";
import ROUTES from "@/constants/routes";
import { BsChatDots } from "react-icons/bs";
import { CgMenuRound } from "react-icons/cg";
import { FaNewspaper, FaQuestionCircle, FaUsersCog } from "react-icons/fa";
import { FaMapLocationDot } from "react-icons/fa6";
import { IoNewspaperOutline, IoNotificationsCircle } from "react-icons/io5";
import {
  MdBusiness,
  MdBusinessCenter,
  MdModelTraining,
  MdOutlineFolder,
  MdOutlineReviews,
  MdPages,
  MdPermMedia,
  MdSettings,
  MdWorkHistory,
} from "react-icons/md";
import { RiDashboard2Fill } from "react-icons/ri";
import { VscFeedback } from "react-icons/vsc";

const leftSidebarData = [
  {
    tabCategory: "Menu",
    tabNameList: [
      // {
      //   id: "Dashboard",
      //   tabName: "Dashboards",
      //   tabIcon: <RiDashboard2Fill />,
      //   pathName: ROUTES.ADMIN_DASHBOARD_ECOMMERCE,
      //   tabDropdownList: [],
      // },

      // News ---
      {
        id: "News",
        tabName: "News & Events",
        tabIcon: <IoNewspaperOutline />,
        required_permissions: [
          PERMISSIONS.NEWS.VIEW_ALL_NEWS_ARTICLES,
          PERMISSIONS.NEWS.ADD_NEWS_ARTICLE,
          PERMISSIONS.NEWS.EDIT_NEWS_ARTICLE,
        ],
        tabDropdownList: [
          {
            id: "news-view",
            parentTabId: "News",
            tabName: "All News",
            pathName: ROUTES.ADMIN_ALL_NEWS_ARTICLES,
            required_permission: PERMISSIONS.NEWS.VIEW_ALL_NEWS_ARTICLES,
            tabDropdownList: [],
          },
          {
            id: "news-create",
            parentTabId: "News",
            tabName: "Create News",
            pathName: ROUTES.ADMIN_CREATE_NEWS_ARTICLE,
            required_permission: PERMISSIONS.NEWS.ADD_NEWS_ARTICLE,
            tabDropdownList: [],
          },
        ],
      },

      // Service ---
      {
        id: "Service",
        tabName: "Service Hub",
        tabIcon: <MdBusinessCenter />,
        required_permissions: [
          PERMISSIONS.SERVICE.VIEW_ALL_SERVICES,
          PERMISSIONS.SERVICE.ADD_SERVICE,
          PERMISSIONS.SERVICE.EDIT_SERVICE,
        ],
        tabDropdownList: [
          {
            id: "service-view",
            parentTabId: "Service",
            tabName: "Services",
            pathName: ROUTES.ADMIN_ALL_SERVICES,
            required_permission: PERMISSIONS.SERVICE.VIEW_ALL_SERVICES,
            tabDropdownList: [],
          },
          {
            id: "service-create",
            parentTabId: "Service",
            tabName: "Create New",
            pathName: ROUTES.ADMIN_CREATE_SERVICE,
            required_permission: PERMISSIONS.SERVICE.ADD_SERVICE,
            tabDropdownList: [],
          },
        ],
      },

      // Start Your Business ---
      {
        id: "Investment",
        tabName: "Business Investment",
        tabIcon: <MdBusiness />,
        required_permissions: [
          PERMISSIONS.INVESTMENT.VIEW_ALL_INVESTMENTS,
          PERMISSIONS.INVESTMENT.ADD_INVESTMENT,
          PERMISSIONS.INVESTMENT.EDIT_INVESTMENT,
        ],
        tabDropdownList: [
          {
            id: "investment-view",
            parentTabId: "Investment",
            tabName: "Fileds",
            pathName: ROUTES.ADMIN_ALL_INVESTMENTS,
            required_permission: PERMISSIONS.INVESTMENT.VIEW_ALL_INVESTMENTS,
            tabDropdownList: [],
          },
          {
            id: "investment-create",
            parentTabId: "Investment",
            tabName: "Create New",
            pathName: ROUTES.ADMIN_CREATE_INVESTMENT,
            required_permission: PERMISSIONS.INVESTMENT.EDIT_INVESTMENT,
            tabDropdownList: [],
          },
        ],
      },

      // FAQ ---
      {
        id: "FAQ",
        tabName: "FAQ Console",
        tabIcon: <FaQuestionCircle />,
        required_permissions: [
          PERMISSIONS.FAQ.VIEW_ALL_FAQS,
          PERMISSIONS.FAQ.ADD_FAQ,
          PERMISSIONS.FAQ.EDIT_FAQ,
          PERMISSIONS.FAQ_CATEGORY.VIEW_ALL_FAQ_CATEGORIES,
          PERMISSIONS.FAQ_CATEGORY.ADD_FAQ_CATEGORY,
          PERMISSIONS.FAQ_CATEGORY.EDIT_FAQ_CATEGORY,
        ],
        tabDropdownList: [
          {
            id: "faq-management",
            parentTabId: "FAQ",
            tabName: "Manage FAQs",
            pathName: "#",
            required_permissions: [
              PERMISSIONS.FAQ.VIEW_ALL_FAQS,
              PERMISSIONS.FAQ.ADD_FAQ,
              PERMISSIONS.FAQ.EDIT_FAQ,
            ],
            tabDropdownList: [
              {
                id: "faq-management-view",
                parentTabId: "FAQ",
                firstChildId: "faq-management",
                tabName: "FAQs",
                pathName: ROUTES.ADMIN_ALL_FAQS,
                required_permission: PERMISSIONS.FAQ.VIEW_ALL_FAQS,
                tabDropdownList: [],
              },
              {
                id: "faq-management-create",
                parentTabId: "FAQ",
                firstChildId: "faq-management",
                tabName: "Create",
                pathName: ROUTES.ADMIN_CREATE_FAQ,
                required_permission: PERMISSIONS.FAQ.ADD_FAQ,
                tabDropdownList: [],
              },
            ],
          },
          {
            id: "faq-category",
            parentTabId: "FAQ",
            tabName: "Manage Category",
            pathName: "#",
            required_permissions: [
              PERMISSIONS.FAQ_CATEGORY.VIEW_ALL_FAQ_CATEGORIES,
              PERMISSIONS.FAQ_CATEGORY.ADD_FAQ_CATEGORY,
              PERMISSIONS.FAQ_CATEGORY.EDIT_FAQ_CATEGORY,
            ],
            tabDropdownList: [
              {
                id: "faq-category-view",
                parentTabId: "FAQ",
                firstChildId: "faq-category",
                tabName: "Categories",
                pathName: ROUTES.ADMIN_ALL_FAQ_CATEGORIES,
                required_permission:
                  PERMISSIONS.FAQ_CATEGORY.VIEW_ALL_FAQ_CATEGORIES,
                tabDropdownList: [],
              },
              {
                id: "faq-category-create",
                parentTabId: "FAQ",
                firstChildId: "faq-category",
                tabName: "Create",
                pathName: ROUTES.ADMIN_CREATE_FAQ_CATEGORY,
                required_permission: PERMISSIONS.FAQ_CATEGORY.ADD_FAQ_CATEGORY,
                tabDropdownList: [],
              },
            ],
          },
        ],
      },

      // NOTIFICATION ---
      {
        id: "NOTIFICATION",
        tabName: "Notification",
        tabIcon: <IoNotificationsCircle />,
        required_permissions: [
          PERMISSIONS.NOTIFICATION.VIEW_ALL_NOTIFICATIONS,
          PERMISSIONS.NOTIFICATION.ADD_NOTIFICATION,
          PERMISSIONS.NOTIFICATION.EDIT_NOTIFICATION,
        ],
        tabDropdownList: [
          {
            id: "notification-view",
            parentTabId: "NOTIFICATION",
            tabName: "Listing",
            pathName: ROUTES.ADMIN_ALL_NOTIFICATIONS,
            required_permission:
              PERMISSIONS.NOTIFICATION.VIEW_ALL_NOTIFICATIONS,
            tabDropdownList: [],
          },
          {
            id: "notification-create",
            parentTabId: "NOTIFICATION",
            tabName: "Create",
            pathName: ROUTES.ADMIN_CREATE_NOTIFICATION,
            required_permission: PERMISSIONS.NOTIFICATION.ADD_NOTIFICATION,
            tabDropdownList: [],
          },
        ],
      },

      // Media ---
      {
        id: "Media",
        tabName: "Media Center",
        tabIcon: <MdPermMedia />,
        required_permissions: [
          // Photo
          PERMISSIONS.PHOTO_MEDIA.VIEW_ALL_PHOTOS,
          PERMISSIONS.PHOTO_MEDIA.ADD_PHOTO,
          PERMISSIONS.PHOTO_MEDIA.EDIT_PHOTO,
          // Video
          PERMISSIONS.VIDEO_MEDIA.VIEW_ALL_VIDEOS,
          PERMISSIONS.VIDEO_MEDIA.ADD_VIDEO,
          PERMISSIONS.VIDEO_MEDIA.EDIT_VIDEO,
          // Movie
          PERMISSIONS.MOVIE_MEDIA.VIEW_ALL_MOVIES,
          PERMISSIONS.MOVIE_MEDIA.ADD_MOVIE,
          PERMISSIONS.MOVIE_MEDIA.EDIT_MOVIE,
        ],
        tabDropdownList: [
          {
            id: "media-photo",
            parentTabId: "Media",
            tabName: "Photo Gallery",
            pathName: "#",
            required_permissions: [
              PERMISSIONS.PHOTO_MEDIA.VIEW_ALL_PHOTOS,
              PERMISSIONS.PHOTO_MEDIA.ADD_PHOTO,
              PERMISSIONS.PHOTO_MEDIA.EDIT_PHOTO,
            ],
            tabDropdownList: [
              {
                id: "media-photo-view",
                parentTabId: "Media",
                firstChildId: "media-photo",
                tabName: "Photos",
                pathName: ROUTES.ADMIN_ALL_PHOTOS,
                required_permission: PERMISSIONS.PHOTO_MEDIA.VIEW_ALL_PHOTOS,
                tabDropdownList: [],
              },
              {
                id: "media-photo-create",
                parentTabId: "Media",
                firstChildId: "media-photo",
                tabName: "Add Photo",
                pathName: ROUTES.ADMIN_CREATE_PHOTO,
                required_permission: PERMISSIONS.PHOTO_MEDIA.ADD_PHOTO,
                tabDropdownList: [],
              },
            ],
          },
          {
            id: "media-video",
            parentTabId: "Media",
            tabName: "Video Gallery",
            pathName: "#",
            required_permissions: [
              PERMISSIONS.VIDEO_MEDIA.VIEW_ALL_VIDEOS,
              PERMISSIONS.VIDEO_MEDIA.ADD_VIDEO,
              PERMISSIONS.VIDEO_MEDIA.EDIT_VIDEO,
            ],
            tabDropdownList: [
              {
                id: "media-video-view",
                parentTabId: "Media",
                firstChildId: "media-video",
                tabName: "Videos",
                pathName: ROUTES.ADMIN_ALL_VIDEOS,
                required_permission: PERMISSIONS.VIDEO_MEDIA.VIEW_ALL_VIDEOS,
                tabDropdownList: [],
              },
              {
                id: "media-video-create",
                parentTabId: "Media",
                firstChildId: "media-video",
                tabName: "Add Video",
                pathName: ROUTES.ADMIN_CREATE_VIDEO,
                required_permission: PERMISSIONS.VIDEO_MEDIA.ADD_VIDEO,
                tabDropdownList: [],
              },
            ],
          },
          {
            id: "media-movie",
            parentTabId: "Media",
            tabName: "Movie Gallery",
            pathName: "#",
            required_permissions: [
              PERMISSIONS.MOVIE_MEDIA.VIEW_ALL_MOVIES,
              PERMISSIONS.MOVIE_MEDIA.ADD_MOVIE,
              PERMISSIONS.MOVIE_MEDIA.EDIT_MOVIE,
            ],
            tabDropdownList: [
              {
                id: "media-movie-view",
                parentTabId: "Media",
                firstChildId: "media-movie",
                tabName: "Movies",
                pathName: ROUTES.ADMIN_ALL_MOVIES,
                required_permission: PERMISSIONS.MOVIE_MEDIA.VIEW_ALL_MOVIES,
                tabDropdownList: [],
              },
              {
                id: "media-movie-create",
                parentTabId: "Media",
                firstChildId: "media-movie",
                tabName: "Add Movie",
                pathName: ROUTES.ADMIN_CREATE_MOVIE,
                required_permission: PERMISSIONS.MOVIE_MEDIA.ADD_MOVIE,
                tabDropdownList: [],
              },
            ],
          },
        ],
      },

      // Testimonial ---
      {
        id: "Testimonial",
        tabName: "Testimonial",
        tabIcon: <MdOutlineReviews />,
        required_permissions: [
          PERMISSIONS.TESTIMONIAL.VIEW_ALL_TESTIMONIALS,
          PERMISSIONS.TESTIMONIAL.ADD_TESTIMONIAL,
        ],
        tabDropdownList: [
          {
            id: "testimonial-view",
            parentTabId: "Testimonial",
            tabName: "Feedback Gallery",
            pathName: ROUTES.ADMIN_ALL_TESTIMONIALS,
            required_permission: PERMISSIONS.TESTIMONIAL.VIEW_ALL_TESTIMONIALS,
            tabDropdownList: [],
          },
          {
            id: "testimonial-create",
            parentTabId: "Testimonial",
            tabName: "Create Feedback",
            pathName: ROUTES.ADMIN_CREATE_TESTIMONIAL,
            required_permission: PERMISSIONS.TESTIMONIAL.ADD_TESTIMONIAL,
            tabDropdownList: [],
          },
        ],
      },

      // Career ---
      {
        id: "Career",
        tabName: "Manage Careers",
        tabIcon: <MdWorkHistory />,
        required_permissions: [
          PERMISSIONS.CAREER.VIEW_ALL_CAREERS,
          PERMISSIONS.CAREER.ADD_CAREER,
        ],
        tabDropdownList: [
          {
            id: "career-view",
            parentTabId: "Career",
            tabName: "Job Listings",
            pathName: ROUTES.ADMIN_ALL_CAREERS,
            required_permission: PERMISSIONS.CAREER.VIEW_ALL_CAREERS,
            tabDropdownList: [],
          },
          {
            id: "career-create",
            parentTabId: "Career",
            tabName: "Add New Job",
            pathName: ROUTES.ADMIN_CREATE_CAREER,
            required_permission: PERMISSIONS.CAREER.ADD_CAREER,
            tabDropdownList: [],
          },
        ],
      },

      // Inquires Center ---
      {
        id: "Inquires",
        tabName: "Inquires Center",
        tabIcon: <BsChatDots />,
        required_permissions: [
          PERMISSIONS.INQURIES.GET_ALL_GENERAL_INQUIRIES,
          PERMISSIONS.INQURIES.GET_ALL_BUSINESS_INQUIRIES,
          PERMISSIONS.INQURIES.GET_ALL_SERVICE_INQUIRIES,
          PERMISSIONS.INQURIES.GET_ALL_BUSINESS_CLUB_INQUIRIES,
          PERMISSIONS.INQURIES.GET_ALL_CAREER_INQUIRIES,
          PERMISSIONS.INQURIES.GET_ALL_PARTNERSHIP_INQUIRIES,
          PERMISSIONS.INQURIES.GET_ALL_CONSULTING_INQUIRIES,
        ],
        tabDropdownList: [
          {
            id: "inquires-general",
            parentTabId: "Inquires",
            tabName: "General Inquires",
            pathName: ROUTES.ADMIN_ALL_GENERAL_INQUIRIES,
            required_permission: PERMISSIONS.INQURIES.GET_ALL_GENERAL_INQUIRIES,
            tabDropdownList: [],
          },
          {
            id: "inquires-business",
            parentTabId: "Inquires",
            tabName: "Business Inquires",
            pathName: ROUTES.ADMIN_ALL_BUSINESS_INQUIRIES,
            required_permission:
              PERMISSIONS.INQURIES.GET_ALL_BUSINESS_INQUIRIES,
            tabDropdownList: [],
          },
          {
            id: "inquires-service",
            parentTabId: "Inquires",
            tabName: "Service Inquires",
            pathName: ROUTES.ADMIN_ALL_SERVICE_INQUIRIES,
            required_permission: PERMISSIONS.INQURIES.GET_ALL_SERVICE_INQUIRIES,
            tabDropdownList: [],
          },
          {
            id: "inquires-business-club",
            parentTabId: "Inquires",
            tabName: "Business Club Inquires",
            pathName: ROUTES.ADMIN_ALL_BUSINESS_CLUB_INQUIRIES,
            required_permission:
              PERMISSIONS.INQURIES.GET_ALL_BUSINESS_CLUB_INQUIRIES,
            tabDropdownList: [],
          },
          {
            id: "inquires-career",
            parentTabId: "Inquires",
            tabName: "Career Inquires",
            pathName: ROUTES.ADMIN_ALL_CAREER_INQUIRIES,
            required_permission: PERMISSIONS.INQURIES.GET_ALL_CAREER_INQUIRIES,
            tabDropdownList: [],
          },
          {
            id: "inquires-partnership",
            parentTabId: "Inquires",
            tabName: "Partnership Inquires",
            pathName: ROUTES.ADMIN_ALL_PARTNERSHIP_INQUIRIES,
            required_permission:
              PERMISSIONS.INQURIES.GET_ALL_PARTNERSHIP_INQUIRIES,
            tabDropdownList: [],
          },
          {
            id: "inquires-consulting",
            parentTabId: "Inquires",
            tabName: "Consulting Inquires",
            pathName: ROUTES.ADMIN_ALL_CONSULTING_INQUIRIES,
            required_permission:
              PERMISSIONS.INQURIES.GET_ALL_CONSULTING_INQUIRIES,
            tabDropdownList: [],
          },
        ],
      },

      {
        id: "Files",
        tabName: "Files Console",
        tabIcon: <MdOutlineFolder />,
        required_permissions: [
          PERMISSIONS.FILE.VIEW_ALL_FILES,
          PERMISSIONS.FILE.ADD_FILE,
        ],
        tabDropdownList: [
          {
            id: "files-view",
            parentTabId: "Files",
            tabName: "File Lists",
            pathName: ROUTES.ADMIN_ALL_FILES,
            required_permission: PERMISSIONS.FILE.VIEW_ALL_FILES,
            tabDropdownList: [],
          },
          {
            id: "files-create",
            parentTabId: "Files",
            tabName: "Create File",
            pathName: ROUTES.ADMIN_CREATE_FILE,
            required_permission: PERMISSIONS.FILE.ADD_FILE,
            tabDropdownList: [],
          },
        ],
      },

      {
        id: "Menu",
        tabName: "Menu Management",
        tabIcon: <CgMenuRound />,
        required_permissions: [
          PERMISSIONS.MENU_MANAGEMENT.VIEW_ALL_MENUS,
          PERMISSIONS.MENU_MANAGEMENT.ADD_MENU,
        ],
        tabDropdownList: [
          {
            id: "menu-view",
            parentTabId: "Menu",
            tabName: "All Menus",
            pathName: ROUTES.ADMIN_MENU_LISTS,
            required_permission: PERMISSIONS.MENU_MANAGEMENT.VIEW_ALL_MENUS,
            tabDropdownList: [],
          },

          {
            id: "menu-create",
            parentTabId: "Menu",
            tabName: "Create Menu",
            pathName: ROUTES.ADMIN_ADD_NEW_MENU,
            required_permission: PERMISSIONS.MENU_MANAGEMENT.ADD_MENU,
            tabDropdownList: [],
          },
        ],
      },

      {
        id: "pages-setup",
        tabName: "CMS Setup",
        tabIcon: <MdPages />,
        required_permissions: [
          PERMISSIONS.CMS_SETUP.VIEW_ALL_PAGES,
          PERMISSIONS.CMS_SETUP.ADD_PAGE,
        ],
        tabDropdownList: [
          {
            id: "pages-setup-view",
            parentTabId: "pages-setup",
            tabName: "All Pages",
            pathName: ROUTES.ADMIN_CMS_ALL_PAGES,
            required_permission: PERMISSIONS.CMS_SETUP.VIEW_ALL_PAGES,
            tabDropdownList: [],
          },
          {
            id: "pages-setup-create",
            parentTabId: "pages-setup",
            tabName: "Add New Page",
            pathName: ROUTES.ADMIN_CMS_CREATE_PAGE,
            required_permission: PERMISSIONS.CMS_SETUP.ADD_PAGE,
            tabDropdownList: [],
          },
        ],
      },

      {
        id: "Configurations",
        tabName: "Setup & Configurations",
        tabIcon: <MdSettings />,
        required_permissions: [
          PERMISSIONS.LANGUAGE.VIEW_ALL_LANGUAGES,
          PERMISSIONS.LANGUAGE.ADD_LANGUAGE,
          PERMISSIONS.WEBSITE_SETUP.GENERAL_SETTINGS,
          PERMISSIONS.WEBSITE_SETUP.FOOTER_SETUP,
        ],
        tabDropdownList: [
          {
            id: "configurations-language",
            parentTabId: "Configurations",
            tabName: "Languages",
            pathName: "#",
            required_permissions: [
              PERMISSIONS.LANGUAGE.VIEW_ALL_LANGUAGES,
              PERMISSIONS.LANGUAGE.ADD_LANGUAGE,
            ],
            tabDropdownList: [
              {
                id: "configurations-language-view",
                parentTabId: "Configurations",
                firstChildId: "configurations-language",
                tabName: "All Languages",
                pathName: ROUTES.ADMIN_ALL_LANGUAGES,
                required_permission: PERMISSIONS.LANGUAGE.VIEW_ALL_LANGUAGES,
                tabDropdownList: [],
              },
              {
                id: "configurations-language-create",
                parentTabId: "Configurations",
                firstChildId: "configurations-language",
                tabName: "Create Language",
                pathName: ROUTES.ADMIN_CREATE_LANGUAGE,
                required_permission: PERMISSIONS.LANGUAGE.ADD_LANGUAGE,
                tabDropdownList: [],
              },
            ],
          },
          {
            id: "configurations-appearance",
            parentTabId: "Configurations",
            tabName: "Appearance",
            pathName: ROUTES.ADMIN_WEBSITE_APPEARANCE_SETUP,
            required_permission: PERMISSIONS.WEBSITE_SETUP.GENERAL_SETTINGS,
            tabDropdownList: [],
          },
          {
            id: "configurations-footer",
            parentTabId: "Configurations",
            tabName: "Footer",
            pathName: ROUTES.ADMIN_WEBSITE_FOOTER_SETUP,
            required_permission: PERMISSIONS.WEBSITE_SETUP.FOOTER_SETUP,
            tabDropdownList: [],
          },
        ],
      },

      {
        id: "Staff",
        tabName: "Staff Management",
        tabIcon: <FaUsersCog />,
        required_permissions: [
          PERMISSIONS.STAFF.VIEW_ALL_STAFFS,
          PERMISSIONS.STAFF.EDIT_STAFF,
          PERMISSIONS.STAFF.VIEW_STAFF_ROLES,
          PERMISSIONS.STAFF.ADD_STAFF_ROLE,
          PERMISSIONS.STAFF.EDIT_STAFF_ROLE,
        ],
        tabDropdownList: [
          {
            id: "staff-view",
            parentTabId: "Staff",
            tabName: "All Staff",
            pathName: ROUTES.ADMIN_ALL_STAFF,
            required_permission: PERMISSIONS.STAFF.VIEW_ALL_STAFFS,
            tabDropdownList: [],
          },
          {
            id: "staff-role",
            parentTabId: "Staff",
            tabName: "Roles",
            pathName: "#",
            required_permissions: [
              PERMISSIONS.STAFF.VIEW_STAFF_ROLES,
              PERMISSIONS.STAFF.ADD_STAFF_ROLE,
              PERMISSIONS.STAFF.EDIT_STAFF_ROLE,
            ],
            tabDropdownList: [
              {
                id: "staff-role-view",
                parentTabId: "Staff",
                firstChildId: "staff-role",
                tabName: "All Roles",
                pathName: ROUTES.ADMIN_STAFF_ALL_ROLES,
                required_permission: PERMISSIONS.STAFF.VIEW_STAFF_ROLES,
                tabDropdownList: [],
              },
              {
                id: "staff-role-create",
                parentTabId: "Staff",
                firstChildId: "staff-role",
                tabName: "Create Role",
                pathName: ROUTES.ADMIN_STAFF_CREATE_ROLE,
                required_permission: PERMISSIONS.STAFF.ADD_STAFF_ROLE,
                tabDropdownList: [],
              },
            ],
          },
        ],
      },
    ],
  },
];

export default leftSidebarData;
